import { useTranslation } from '@jq4race/i18n';
import { ShieldAlert } from 'lucide-react';

export interface AccessDeniedStateProps {
  /**
   * Overrides the default `common:accessDenied.description` copy — pass the
   * backend's own message (e.g. "Solo Org Admin o Supervisor pueden
   * gestionar eventos") when it's more specific than the generic fallback.
   */
  message?: string;
}

/**
 * Reusable "you don't have permission" panel for a screen whose list load
 * failed with HTTP 403.
 *
 * Render this INSTEAD OF a table's normal empty state whenever the load
 * failed with `isForbiddenError(error)` — never let a 403 (a permission
 * problem) look identical to "there is no data" (see EventsPage.tsx for the
 * confirmed production incident this fixes, and the audit report for every
 * other screen following the same pattern).
 */
export function AccessDeniedState({ message }: AccessDeniedStateProps) {
  const { t } = useTranslation();
  return (
    <div role="alert" className="flex flex-col items-center justify-center gap-3 py-12 text-center">
      <ShieldAlert className="h-10 w-10 text-jq-danger" strokeWidth={1.25} />
      <p className="text-[14px] font-medium text-jq-charcoal">{t('common:accessDenied.title')}</p>
      <p className="max-w-sm text-[13px] text-jq-graphite">
        {message ?? t('common:accessDenied.description')}
      </p>
    </div>
  );
}
